import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import {
  API_PAYMENT_SERVICE,
  API_PAYMENT_SERVICE_MENU,
} from "../../utils/apis";
import {
  createDeleteAction,
  createEditAction,
  createViewAction,
  formatDate,
  getForm,
  getRegister,
  objectWithUnsetKeys,
} from "../../utils/helpers";
import { URL_PAYMENT_SERVICES } from "../../utils/urls";
import useGet from "../common/useGet";
import { BooleanTags } from "../../components/common/registerUtils";

const url = URL_PAYMENT_SERVICES;

// REGISTER
export const usePaymentServices = ({ id }) => {
  const tableColumns = () => [
    { id: "display_text", header: "Service Name", filter: {} },
    { id: "screen_category", header: "Screen Category", filter: {} },
    { id: "attached_paycode", header: "Paycode", filter: {} },
    // { id: "description", header: "Description", filter: {} },
    { id: "trigger_selection", header: "Trigger Selection", filter: {} },
    { id: "prompt_validation", header: " Prompt Validation", filter: {} },
    { id: "prompt_payment", header: "Prompt Payment", filter: {} },
    { id: "is_active", header: "Is Active", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        prompt_validation: <BooleanTags status={item?.prompt_validation} />,
        prompt_payment: <BooleanTags status={item?.prompt_payment} />,
        is_active: <BooleanTags status={item?.is_active} />,

        actions: (
          <FormActions
            actions={[
              createViewAction(url, item?.id),
              createDeleteAction(
                `${API_PAYMENT_SERVICE}${item?.id}/`,
                `${item?.display_text}`,
              ),
              createEditAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Payment Service Details",
          fields: {
            ID: item?.id,
            display_text: item?.display_text,
            screen_category: item?.screen_category,
            description: item?.description,
            attached_paycode: item?.attached_paycode,
            prompt_payment: <BooleanTags status={item?.prompt_payment} />,
            prompt_validation: <BooleanTags status={item?.prompt_validation} />,
            is_active: <BooleanTags status={item?.is_active} />,
            generated_on: formatDate(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  const customApi = `${API_PAYMENT_SERVICE}${id}/`;

  return { tableData, tableColumns, formRoute, customApi, viewData };
};

// FORM
export const usePaymentServicesForm = () => {
  const { loadData, loading, data: paymentServiceData } = useGet();

  useEffect(() => loadData({ api: API_PAYMENT_SERVICE_MENU }), []);

  const sections: any = [
    {
      title: "Payment  Service Details",
      fields: [
        {
          field_name: "display_text",
          label: "Service Name",
          type: "text",
        },
        {
          field_name: "attached_paycode",
          label: "Paycode",
          type: "text",
        },
        {
          field_name: "description",
          label: "Description",
          type: "text",
        },
        {
          field_name: "screen_category",
          type: "select",
          label: "Parent Category",
          props: { required: true },
          options_data: paymentServiceData,
          loading,
        },
        {
          field_name: "prompt_validation",
          type: "checkbox",
        },
        {
          field_name: "prompt_payment",
          type: "checkbox",
        },
        {
          field_name: "is_active",
          type: "checkbox",
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  return { sections, redirect };
};

// SUBMIT
export function submitPaymentServices(payload: any, id: string | number) {
  let params = { ...payload };
  if (id) {
    params = { ...objectWithUnsetKeys(payload, ["display_image"]) };
  }

  return {
    id,
    api: API_PAYMENT_SERVICE,
    params,
  };
}
